import { ISupportSpotlightCard as IContentfulSupportCard } from 'marketing-site/@types/generated/contentful'
import { IProps as ISupportSpotlightCard } from 'marketing-site/src/library/elements/SupportSpotlightCard'
import { transformImage } from './ContentfulImage'

export function transformSupportSpotlightCard({
  fields,
}: IContentfulSupportCard): ISupportSpotlightCard {
  return {
    ...fields,
    eyebrow: fields?.eyebrow,
    title: fields.title,
    description: fields.fullDescription,
    video: fields.video && fields.video?.fields.file.url,
    fallbackImageRef: transformImage(fields.fallbackImageRef),
  }
}
